/*
 * Register your Interest — form submission + Klaviyo client-side capture.
 * Paired with snippets/register-interest.liquid.
 *
 * NO modal machinery here. The theme's <x-modal> owns open/close, the focus
 * trap, Escape, scroll lock and the portal to <body>. This file only submits.
 *
 * On submit:
 *   - ALWAYS POST /client/events ("Registered Interest") carrying the full
 *     product context, the request text and the preferred contact channel.
 *     The success state is gated on THIS call: it is the lead, and both the
 *     concierge alert and the customer confirmation are flows on this metric.
 *     Retries once on a 5xx / network error.
 *   - IF marketing consent is checked: POST /client/subscriptions to the
 *     HOLDING list atelier__interest-registrants (Vq3Js6). Best-effort.
 *
 * Why a holding list and not atelier__members: subscribing here records
 * profile-level email marketing consent through Klaviyo's proper consent path,
 * but does NOT trigger "Welcome Series - Atelier", which fires on being added
 * to atelier__members (TceZsQ). The Registered Interest flow adds the profile
 * to atelier__members after a 7-day delay, so the welcome arrives a week after
 * the registration and its copy lives in exactly one flow. Do not point
 * KLAVIYO_LIST_ID at TceZsQ; that would fire the welcome immediately and
 * collide with the confirmation email.
 *
 * Klaviyo public company id + list id are not secrets (public client API).
 * The concierge notification is a Klaviyo flow on the metric, not an email
 * sent from here.
 */
(function () {
  if (window.__lunburgRI) return;
  window.__lunburgRI = true;

  var KLAVIYO_COMPANY_ID = 'TJ3xFH';
  var KLAVIYO_LIST_ID = 'Vq3Js6'; // atelier__interest-registrants (holding list)
  var KLAVIYO_REVISION = '2026-04-15';
  var EVENT_NAME = 'Registered Interest';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  ready(function () {
    var modal = document.querySelector('[data-ri-modal]');
    if (!modal) return;

    var form = modal.querySelector('[data-ri-form]');
    var formWrap = modal.querySelector('[data-ri-form-wrap]');
    var success = modal.querySelector('[data-ri-success]');
    var channelEl = modal.querySelector('[data-ri-channel]');
    var errorEl = modal.querySelector('[data-ri-error]');
    var submitBtn = form ? form.querySelector('[type="submit"]') : null;
    if (!form) return;

    function attr(name) { return modal.getAttribute(name) || ''; }
    function fld(name) { return form.querySelector('[name="' + name + '"]'); }
    function val(name) { var f = fld(name); return f ? (f.value || '').trim() : ''; }

    /* Reset to the form state each time the modal is opened, so a second
       enquiry in the same page view does not land on the previous success
       panel. x-modal's own events are not relied on; the trigger click is
       enough and fires before the panel is shown. */
    document.querySelectorAll('[aria-controls="' + modal.id + '"]').forEach(function (t) {
      t.addEventListener('click', function () {
        if (formWrap) formWrap.hidden = false;
        if (success) success.hidden = true;
        if (errorEl) errorEl.hidden = true;
        if (submitBtn) submitBtn.disabled = false;
      });
    });

    /* Klaviyo rejects a whole profile block on a malformed phone_number, which
       would silently cost us the lead. Only promote the typed value to the
       canonical field when it is unambiguously E.164; otherwise keep it as a
       custom property so the concierge still sees exactly what was typed. */
    function e164(v) {
      var t = (v || '').replace(/[^\d+]/g, '');
      return /^\+[1-9]\d{7,14}$/.test(t) ? t : '';
    }

    function klaviyo(path, body) {
      return fetch('https://a.klaviyo.com/client/' + path + '?company_id=' + KLAVIYO_COMPANY_ID, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': KLAVIYO_REVISION },
        body: JSON.stringify(body)
      });
    }
    function klaviyoRetry(path, body) {
      return klaviyo(path, body).then(function (r) {
        if (r && r.status >= 500) { return klaviyo(path, body); }
        return r;
      }).catch(function () { return klaviyo(path, body); });
    }
    function ok2xx(r) { return r && r.status >= 200 && r.status < 300; }

    function showSuccess(channel) {
      if (channelEl && channel) channelEl.textContent = channel.toLowerCase();
      if (formWrap) formWrap.hidden = true;
      if (success) success.hidden = false;
    }
    function showError(msg) {
      if (errorEl) {
        errorEl.textContent = msg || 'Something went wrong. Please try again, or write to concierge@lunburg.com.';
        errorEl.hidden = false;
      }
      if (submitBtn) submitBtn.disabled = false;
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errorEl) errorEl.hidden = true;

      if (!form.checkValidity()) { form.reportValidity(); return; }
      if (submitBtn) submitBtn.disabled = true;

      var email = val('email');
      var phoneRaw = val('phone');
      var phoneE164 = e164(phoneRaw);
      var channel = val('preferred_contact');
      var consent = !!(fld('marketing_consent') && fld('marketing_consent').checked);

      var profileAttrs = {
        email: email,
        first_name: val('first_name'),
        last_name: val('last_name'),
        properties: {
          interest_phone: phoneRaw,
          interest_preferred_contact: channel
        }
      };
      if (phoneE164) profileAttrs.phone_number = phoneE164;

      var eventBody = { data: { type: 'event', attributes: {
        properties: {
          product: attr('data-ri-product-title'),
          product_id: attr('data-ri-product-id'),
          product_handle: attr('data-ri-product-handle'),
          product_url: attr('data-ri-product-url'),
          product_type: attr('data-ri-product-type'),
          vendor: attr('data-ri-vendor'),
          variant_id: attr('data-ri-variant-id'),
          sku: attr('data-ri-sku'),
          price: attr('data-ri-price'),
          currency: attr('data-ri-currency'),
          leather_tone: attr('data-ri-config-leather'),
          profile_size: attr('data-ri-config-profile'),
          interior_configuration: attr('data-ri-config-interior'),
          phone: phoneRaw,
          preferred_contact: channel,
          message: val('message'),
          marketing_consent: consent
        },
        metric: { data: { type: 'metric', attributes: { name: EVENT_NAME } } },
        profile: { data: { type: 'profile', attributes: profileAttrs } }
      } } };

      // Consent-gated, best-effort; runs in parallel and never blocks the UX.
      if (consent) {
        klaviyoRetry('subscriptions', { data: { type: 'subscription', attributes: {
          custom_source: 'Register your Interest form',
          profile: { data: { type: 'profile', attributes: {
            email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
          } } }
        }, relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST_ID } } } } })
          .then(function (r) { if (!ok2xx(r)) { try { console.warn('RI: subscription not accepted', r && r.status); } catch (e) {} } });
      }

      klaviyoRetry('events', eventBody).then(function (r) {
        if (ok2xx(r)) { showSuccess(channel); }
        else { showError(); }
      }).catch(function () { showError(); });
    });
  });
})();
